import { ItemType, TrackType } from "../../../types";
import { ItemSettings } from "../context";

export const findSelectedItem = (
  tracks: TrackType[],
  selectedItem: string | null
): ItemType | undefined => {
  if (!selectedItem) return undefined;

  for (const track of tracks) {
    const foundItem = track.items.find((item) => item.id === selectedItem);
    if (foundItem) return foundItem;
  }

  return undefined;
};

export const getSelectedItemSettings = (
  selectedItemObject: ItemType | undefined
): ItemSettings | null => {
  if (!selectedItemObject) {
    return null;
  }

  switch (selectedItemObject.type) {
    case "text":
      return {
        type: "text",
        content: { text: selectedItemObject.text },
        position: selectedItemObject.position,
        rotation: selectedItemObject.rotation,
        size: selectedItemObject.size,
        configuration: selectedItemObject.configuration,
      };

    case "solid":
      return {
        type: "solid",
        position: selectedItemObject.position,
        rotation: selectedItemObject.rotation,
        size: selectedItemObject.size,
        configuration: selectedItemObject.configuration,
      };

    case "image":
      return {
        type: "image",
        position: selectedItemObject.position,
        rotation: selectedItemObject.rotation,
        size: selectedItemObject.size,
      };

    case "video":
      return {
        type: "video",
        position: selectedItemObject.position,
        rotation: selectedItemObject.rotation,
        configuration: selectedItemObject.configuration,
      };

    case "audio":
      return null;

    default:
      return null;
  }
};

export function calculateTotalDurationInFrames(tracks: TrackType[]): number {
  if (!tracks || !Array.isArray(tracks) || tracks.length === 0) {
    return 300;
  }

  let maxEndFrame = 0;

  for (const track of tracks) {
    if (track.items && Array.isArray(track.items)) {
      for (const item of track.items) {
        const itemEnd = (item.from || 0) + (item.durationInFrames || 0);

        if (itemEnd > maxEndFrame) {
          maxEndFrame = itemEnd;
        }

        if (
          item.type === "video" &&
          item.videoDurationInSeconds &&
          (item as any).fps
        ) {
          const videoEndFrame =
            (item.from || 0) + item.videoDurationInSeconds * (item as any).fps;
          if (videoEndFrame > maxEndFrame) {
            maxEndFrame = videoEndFrame;
          }
        }
      }
    }
  }

  return Math.ceil(maxEndFrame) + 30;
}
